/** 도메인 규칙 위반. API 계층에서 HTTP 상태로 변환된다. */
export type DomainErrorCode =
  | 'VALIDATION'
  | 'UNAUTHENTICATED'
  | 'FORBIDDEN'
  | 'NOT_FOUND'
  | 'CONFLICT'
  | 'LOCKED'
  | 'CONSENT_REQUIRED';

export class DomainError extends Error {
  constructor(public readonly code: DomainErrorCode, message: string, public readonly details?: unknown) {
    super(message);
    this.name = 'DomainError';
  }
}

export const fail = (code: DomainErrorCode, message: string, details?: unknown): never => {
  throw new DomainError(code, message, details);
};
